module.exports = "<div ng-include=\"pageTpl\"></div>";